import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TAvailableEmsResponse,
	TPartnersResponse,
	TReferralsPartnersResponse,
	TReferralsStore,
	TPartnerReportsResponse,
} from './types';

// ==========================================:
const getReferralsState = (state: TStoreState): TReferralsStore => state.referrals;
export const getReferrals = createSelector(
	[getReferralsState],
	(referrals: TReferralsStore) => referrals,
);

// ====================================================:
export const getReferralsPartnersIsLoad = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): boolean => referrals.referralsPartnersLoader,
);

// ====================================================:
export const getReferralsPartners = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): TReferralsPartnersResponse => referrals.referralsPartners,
);

// ====================================================:
export const getPartners = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): TPartnersResponse => referrals.partners,
);

// ====================================================:
export const getPartnersIsLoad = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): boolean => referrals.partnersLoader,
);

// ====================================================:
export const getAvailableEms = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): TAvailableEmsResponse => referrals.availableEms,
);

// ====================================================:
export const getAvailableEmsIsLoad = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): boolean => referrals.availableEmsLoader,
);

// ====================================================:

export const getAvailableEmsOptions = createSelector(
	[getAvailableEms],
	(availableEms: TAvailableEmsResponse): TAvailableEmsResponse => availableEms,
);

// ====================================================:
export const getPartnerReports = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): TPartnerReportsResponse => referrals.partnerReports,
);

// ====================================================:
export const getPartnerReportsIsLoad = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): boolean => referrals.partnerReportsLoader,
);

// ====================================================:
export const getDownloadingPartnerReportIds = createSelector(
	[getReferrals],
	(referrals: TReferralsStore): number[] => referrals.downloadingPartnerReportIds,
);
